import { t } from 'i18next';
import type { ErrorResponse } from '../types';

export abstract class PtwError extends Error {
  static async extractError(response: Response): Promise<ErrorResponse> {
    try {
      return await response.json();
    } catch {
      return {
        errorType: 'PtwException',
        message: t('UnknownErrorHasOccurred'),
      };
    }
  }
}
